export default __webpack_public_path__ + "static/media/tractorGreen.af73f8ca.svg";